import { formatUserName } from "@impero-com/common/utils/formatting";
import { assertNever } from "@impero-com/common/utils/obj";

import { ControlResultStepWithoutFields } from "api/generated/model/controlResultStepWithoutFields";
import { LookupContext } from "utils/controlResults/lookupContext";

export function getStepActorName(
    step: ControlResultStepWithoutFields,
    lookupContext: LookupContext
): string {
    const kind = step.kind;
    switch (kind.type) {
        case "User":
            const userId = kind.userId;
            const user = lookupContext.usersById.getOrThrow(userId);
            return formatUserName(user);
        case "Pool":
            const poolId = kind.userPoolId;
            const pool =
                lookupContext.controlResultUserPoolsById.getOrThrow(poolId);
            return pool.name;
        default:
            return assertNever(kind);
    }
}
